import React       from 'react';
import ReactDom    from 'react-dom';
// -------------------------------------------------------

class InputCheckbox extends React.Component {
  update() {
    this.props.update_ev.bind(this)((this.item.checked) ? 1 : 0);
  }
  
  render() {
    let data = this.props.data;
    
    return (
      <div className="checkbox-frame">
        {( data.default == 1 )
          ? <input type="checkbox" id={data.id} ref={(input) => { this.item = input }} onChange={this.update.bind(this)} className="checkbox" defaultChecked />
          : <input type="checkbox" id={data.id} ref={(input) => { this.item = input }} onChange={this.update.bind(this)} className="checkbox" />
        }
        <label className="checkbox" htmlFor={data.id}>{(data.checkbox_name != undefined) ? data.checkbox_name : data.name}</label>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InputCheckbox;